import {
  doRequest,
  doError
} from './common';

export const queryCoverage = async ({
  policy_type,
  customer_number = null,
  phone_number = null,
  post_code = null,
  customer_name = null
}) => {
  try {
    return await doRequest({
      url: '/api/customer-coverage',
      params: {
        'policy-type': policy_type,
        'customer-number': customer_number,
        'phone-number': phone_number,
        'post-code': post_code,
        'customer-name': customer_name
      },
      doNormalize: false
    });
  } catch (error) {
    throw new Error(doError(error));
  }
};

export const showCoverage = async ({
  policy_type,
  customer_number = null,
  phone_number = null,
  post_code = null,
  customer_name = null
}, id) => {
  try {
    return await doRequest({
      url: `/api/customer-coverage/${id}`,
      params: {
        'policy-type': policy_type,
        'customer-number': customer_number,
        'phone-number': phone_number,
        'post-code': post_code,
        'customer-name': customer_name
      },
      doNormalize: false
    });
  } catch (error) {
    throw new Error(doError(error));
  }
}


// WEBPACK FOOTER //
// ./src/services/api/coverage.js